import * as React from 'react';
import {Container, Row, Col} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft, faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import ShowSelections from './ShowSelections';

export default (props) => {

    const commonStyles = {padding: '4px'}
    const getStyle = (type) => {
        let style
        switch( type){
            case 'track':
                style = {backgroundColor: '#007bff', color:'white'}
                break
            case 'eventClass':
                style = {backgroundColor: '#dc3545', color:'white'}
                break
            case 'checkPoint':
                style = {backgroundColor: '#ffc107', color:'black'}
                break
            default:
                style = {backgroundColor: 'white', color:'black'}
        }
        return style
    }
    const getNameFromList = ( defaultText, list, id) => {
        if( list === undefined || list === null){ 
            return "Alle"
        }
        else if( list.length > 0 && id ){
            const item = list.find( (item) => item.id === id)
            return item ? item.name : 'Alle' 
        }
        else{
            return 'Alle'
        }
    }
    const getCheckPointFromList = ( defaultText, list, id) => {
        if( !list){ 
            return "Ukjent"
        }
        else if( list.length > 0 && id > -1 ) {
            const cp = list.find( (item) => item.sequence === id)
            return cp.name ? cp.name : cp.sequence 
        }
        else{
            return 'Alle'
        }
    }
    const getText = (type, defaultText, list, id) => {
        let returnText
        switch( type){
            case 'track':
                returnText = getNameFromList( defaultText, list, id)
                break
            case 'eventClass':
                returnText = getNameFromList( defaultText, list, id)
                break
            case 'checkPoint':
                returnText = getCheckPointFromList( defaultText, list, id)
                break
            default:
                returnText = "ukjent"
        }
        return returnText
    }
    const selectNextItem = ( list, type, id) => {
        const newId = props.nextIdInSelectorList( list, type, id)
        props.selectItem( type, newId)
    }
    const prevNextItem = ( list, type, id) => {
        const newId = props.prevIdInSelectorList( list, type, id)
        props.selectItem( type, newId)
    }
    const style = {...getStyle( props.type), ...commonStyles}
    const styleRight = {...getStyle( props.type), ...commonStyles,  textAlign:'right'}
    
  return (
        <Container fluid>
              <Row style={style}>
                <Col onClick={() => prevNextItem(props.list, props.type, props.id)}><FontAwesomeIcon icon={faCaretLeft} size="lg" /></Col>
                <Col xs={5} onClick={() => props.showSelection(props.type, props.shouldShowSelection)}>{getText( props.type, props.defaultText, props.list, props.id)} <span style={{textAlign:'right'}}><FontAwesomeIcon icon={faCaretDown} size="lg"/></span></Col>
                <Col onClick={() => selectNextItem(props.list, props.type, props.id)} style={styleRight}><FontAwesomeIcon icon={faCaretRight} size="lg"/></Col>
            </Row>
            <Container fluid>
                { props.shouldShowSelection ?
                    <ShowSelections style={getStyle( props.type)} type={props.type} list={props.list} selectItem={props.selectItem}/> : null
                }
            </Container>
        </Container>
  );
};
